module.exports = __webpack_public_path__ + "img/instrumentos.d433b021.svg";